/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../../../../../atoms/effects/skeletons/utils/SkeletonSettings";
import React from "react";

export const CartRowHeaderSkeleton = (props) => (
    <ContentLoader
        width={"100%"}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        {...props}>

        {/* Shopping cart */}
        <rect x="0" y="10" rx="3" ry="3" width="25%" height="40"/>

        {/* Search bar */}
        <rect x={`calc(25% + 40px)`} y="10" rx="3" ry="3" width="40%" height="40"/>

        {/* Excel import */}
        <rect x={`calc(65% + 100px)`} y="30" rx="3" ry="3" width="10%" height="10"/>

        {/* Clear cart */}
        <rect x={`calc(75% + 120px)`} y="30" rx="3" ry="3" width="10%" height="10"/>

        {/* Product */}
        <rect x="0" y="90" rx="3" ry="3" width="80" height="10"/>

        {/* Packaging info */}
        <rect x="45%" y="90" rx="3" ry="3" width="8%" height="10"/>

        {/* Weight price */}
        <rect x="54%" y="90" rx="3" ry="3" width="8%" height="10"/>

        {/* Unit price */}
        <rect x="63%" y="90" rx="3" ry="3" width="8%" height="10"/>

        {/* Quantity */}
        <rect x="72%" y="90" rx="3" ry="3" width="12%" height="10"/>

        {/* Total price */}
        <rect x="85%" y="90" rx="3" ry="3" width="8%" height="10"/>


    </ContentLoader>
);
